import React, { useEffect } from 'react';
import { useNavigate, Link,useLocation} from 'react-router-dom';
import { BiSolidLeftArrow, BiX } from 'react-icons/bi';

import Camera from "../components/Camera";
import Header from '../components/Header';
import { sendAnalyticsData } from '../utilities/analytics';
const PageBasic = () => {
  sendAnalyticsData('View Page','Captured')
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if(!location.state){
      navigate('/');
    }
  }, [location.state])

  return (
    <>
      <div className='header-bar-wrapper d-flex'>
        <Header className='pb-0 align-items-center header-icon-white'/>
        <Link className='back page-back' style={{top: '35%'}} onClick={() => navigate(-1)}>
          <img className='icon-back icon-white' src='/images/icon-back.png' alt=''/>
        </Link>
      </div>
      <div className='full-height page-headerbar'>
        <div className='navigation d-none d-desktop-flex w-100 pt-2'>
          <Link className='back page-back' onClick={() => navigate(-1)}>
            <img className='icon-back' src='/images/icon-back.png' alt=''/>
          </Link>
        </div>
        <div className='camera-palette-wrapper d-flex flex-column justify-content-center'>
          <Camera/>
        </div>
      </div>
    </>
  );
};

export default PageBasic;
